// src/utils/tokenCookies.js
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

/**
 * Localhostda cookie saqlanmasligi muammosini oldini olish:
 * - HTTPS bo'lmasa secure=false qolsin
 */


/**
 * Default attribute’lar (hamma route’larda o’qilsin, Lax kifoya, secure devda moslashadi).
 * Cookie expire’ni uzoqroq beramiz (masalan 365 kun) — backend o’zi JWT exp’ni tekshiradi.
 */
const attrs = {
  path: "/",
  
  expires: 365, // frontend cookie umrini uzun qilamiz; backend JWT exp baribir ustun
};

/**
 * ENCODINGNI TO'LIQ O'CHIRAMIZ:
 * - write: value'ni aynan qanday bo'lsa shunday yozadi (URL-encode yo'q)
 * - read: xuddi shunday o'qiydi (decode yo'q)
 *
 * Eslatma: bu js-cookie v3 API (withAttributes / withConverter).
 */
const RawCookies = Cookies.withAttributes(attrs).withConverter({
  write: (value) => value,
  read: (value) => value,
});

// === Public API ===
export const getAccessToken = () => RawCookies.get("accessToken") || null;
export const getRefreshToken = () => RawCookies.get("refreshToken") || null;

/**
 * Access tokenni 0.3 kun (~7-8 soat) bilan yozish istasangiz — lekin backend exp baribir tekshiradi.
 * Agar umuman muvofiqlashtirmoqchi bo'lmasangiz, expires berishni ham shart emas — attrs’dagi default ishlaydi.
 */
export const setAccessToken = (token, opts = {}) =>
  RawCookies.set("accessToken", token, { ...opts, expires: 0.3 });

/**
 * Refresh tokenni uzoqroq muddatga cookie’da ushlab turamiz.
 * Backend refresh JWT exp tugasa, baribir yaroqsiz bo'ladi.
 */
export const setRefreshToken = (token, opts = {}) =>
  RawCookies.set("refreshToken", token, { ...opts, expires: 365 });

export const clearTokens = () => {
  RawCookies.remove("accessToken", { path: "/" });
  RawCookies.remove("refreshToken", { path: "/" });
};

/**
 * Decode JWT token and return payload
 * @returns {object|null} Decoded token payload or null if invalid
 */
export const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch (err) {
    console.error("Token decode error:", err);
    return null;
  }
};
